import { errorCellRenderer } from "../components/flowTable";
import { FlowTableColumn } from "../components/flowTable/types";

export const blocoColumns: FlowTableColumn[] = [
  { data: "nome", header: "Nome", type: "text", width: 240 },
  { data: "blocos", header: "Blocos", type: "text", width: 320 },
];

export const blocoMassColumns: FlowTableColumn[] = blocoColumns.map(
  (column) => ({
    ...column,
    renderer: errorCellRenderer,
  }),
);
